import React from "react"
import WidthWrapper from "../../components/elements/Base/WidthWrapper";
import HTMLHead from "../../components/blocks/HTMLHead";
import MetaElement from "../../components/elements/MetaElement";


import * as dayjs from 'dayjs';


const CyberstormAccess = (props) => {
    const [countdown, setCountdown] = React.useState('???');
    const [countdownUnix, setCountdownUnix] = React.useState(0);

    const updateCountdown = () => {
        const date = dayjs();
        const unlock = dayjs('2023-05-01 20:00:00');

        const diff = unlock.diff(date, 'second');

        const days = Math.floor(diff / (60 * 60 * 24));
        const hours = Math.floor(diff / (60 * 60)) % 24;
        const minutes = Math.floor(diff / 60) % 60;
        const seconds = diff % 60;

        setCountdown(`${days.toString().padStart(2, '0')}:${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
        setCountdownUnix(diff);
    }

    React.useEffect(() => {
        updateCountdown();
    }, [])

    setInterval(() => {
        updateCountdown();
    }, 1000)


    return (<>

        <div className='container'>
            <style global jsx>{`
                * {
                    margin: 0;
                    padding: 0;
                }

                :global(html), :global(#__next) {
                    background-color: #ffffff;
                }

                .logo {
                    width: 60%;
                    // min-height: 600px;
                    margin-top: 15px;
                    margin-bottom: 15px;
                    z-index: 800;
                }

                .container {
                    width: 100%;
                    background-color: #000000;
                    position: relative;
                    width: 100%;
                    background-image: url('https://content.krit.ro/landing-assets/dai-o-carte-la-eecc-rev2/backgroundv2.svg');
                    background-size: 100%;
                    background-repeat: no-repeat;
                    background-position: top;
                    background-color: #ffffff;
                }




                .content {
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                }

                 .event-label {
                    max-width: 70%;
                    margin-top: 10px;
                    z-index: 800;
                }

                img {
                    display: block;
                    margin: 0;
                }

                .items {
                    display: flex;
                    flex-direction: column;
                    justify-content: 80%;
                    align-items: center;
                    width: 100%;
                }

                button {
                     font-family: 'Montserrat';
                     font-weight: 700;
                    width: 260px;
                    height: 62px;
                    border-radius: 10px;
                    border: 0;
                    margin-top: 10px;
                    z-index: 1000;
                    margin-right: 10px;
                    cursor: pointer;
                    transition: all 0.1s ease-in-out;
                    font-size: 2rem;
                }

                .register {
                    background-color: #db1f26;
                    color: #FFFFFF;
                }

                 .back {
                    background-color: #ffffff;
                    color: #444444;
                    font-size: 1.2rem;
                    text-decoration: underline;
                }

                .register:hover {
                      box-shadow:
                        0 0 10px 0px #f00;
                }

                .preorder {
                    background-color: #662d91;
                    color: #FFFFFF;

                }

                .preorder:hover {
                     box-shadow:
                        0 0 20px 0px #d0f;

                }

                .buttons {
                    display: flex;
                    align-items: space-between;
                    max-width: 80%;
                    z-index: 1000;
                    margin-bottom: 20px;
                }

                .buttons a {
                    max-width: 300px;
                }

                  .prizes {
                    box-sizing: border-box;
                    max-width: 100%;
                    padding-top: 30px;
                    background-color: #FFFFFF;
                    color: #333333;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }

                .headline, h1 {

                    display: flex;
                    justify-content: center;
                    font-weight: 900;
                    font-size: 2rem;
                    font-family: 'Montserrat';
                    margin-top: 0px;
                }

                .text-content {
                    width: 100%;

                    margin-top: 10px;
                    font-size: 1.3rem;
                    text-align: center;
                    max-width:90%;
                }

                ul {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }

                ul li {
                    text-align: center;
                    list-style-type: none;
                }

                .group {
                    padding: 10px;
                    margin-bottom: 10px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    box-sizing: border-box;
                    border-top: 3px dashed #DDDDDD;
                    width: 100%;
                }

                .group:first-of-type {
                    border-top: none;
                }

                .krit-logo {
                    max-width: 250px;
                    z-index: 1000;
                }

                .prize-photos {
                    display: flex;
                    margin-top: 10px;
                    margin-bottom: 10px;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items:center;

                }

                .prize-photos img {
                    max-width: 50%;
                    height: fit-content;
                }

                h2 {
                    font-weight: 900;
                }

                @media (max-width: 768px) {
                    .logo {
                        width: 100%;
                        margin-bottom: 0;
                    }

                    .buttons {
                        flex-direction: column;
                    }

                    button {
                        height: 42px;
                        margin-top: 20px;
                        font-size: 1.5rem;
                    }

                    .prizes {
                        align-items: flex-start;
                        justify-content: flex-start;
                        text-align: center;
                    }

                    .prize-photos {
                        flex-direction: column;
                    }
                }

                div a {
                    color: red;
                    text-decoration: underline;
                }

            `}</style>
            <HTMLHead/>
            <MetaElement pageId='landing/dai-o-carte-la-eecc'/>

                <div className='content'>
                    <div className='items'>
                        <img className='logo' src="https://content.krit.ro/landing-assets/dai-o-carte-la-eecc-rev2/eecc_r2-m5.svg"/>

                        <div className="buttons">
                            {countdownUnix > 0 ?
                                <button className='register'>
                                    {countdown}
                                </button>
                                : <a href="https://krit.ro/produs/bilet-turneu-eecc-20mai">
                                <button className='register'>
                                    INSCRIE-TE
                                </button>
                            </a>}

                             <a href="https://krit.ro/">
                                <button className='back'>
                                    Inapoi la Krit
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
        </div>
            <WidthWrapper className="xsmall">
                <div className="prizes"  style={{ paddingTop: 0 }}>
                    <div className="group">
                        <h1 style={{ marginTop: 0 }}>
                            DAI O CARTE LA EECC?
                        </h1>
                        <div className="text-content" style={{textAlign: 'center', maxWidth: '90%'}}>
                            Hai pe 20 Mai la East European Comic Con la un turneu Yu-Gi-Oh! TCG de neuitat!
                        </div>
                    </div>

                    <div className="group" style={{ borderTop: 'none'}}>
                        <div className="headline">
                            UNDE, CAND, CUM?
                        </div>

                        <div className="text-content" style={{marginBottom: '0px'}}>
                            <div style={{fontSize: '1.5rem', fontWeight: '700', paddingBottom: '0px'}}>🕑 Sambata, 20 Mai 2023</div>  <strong>12:00 ~ 17:00</strong> <br/><br/>
                            🗺️ Romexpo, Pavilionul B1, TCG Area (Zona B8) <br/>
                            🧑‍🤝‍🧑 Locuri: 24 <br/>
                            Format: Swiss (pana la 5 runde) <br/>
                            Nu este necesar un decklist!
                        </div>
                    </div>

                    <div className="group">
                        <div className="headline">
                            Taxa Participare - &nbsp;<span>89 Lei</span><br/>
                        </div>
                        <div className="text-content">
                            <i>Taxa de participare la turneu <b style={{color: 'red'}}>nu include biletul de acces la Comic Con</b>. Fiecare participant trebuie sa isi asigure biletul de acces la <b>Comic Con</b> inainte de a se inscrie la turneu, disponibil <a href="https://comic-con.ro/tickets/">aici</a>.</i><br/>
                        </div>
                        <div className="text-content">
                            <strong>Premii de participare:</strong>
                            <ul>
                                <li>3 x Booster Packs Cyberstorm Access</li>
                                <li>1 x Booster Pack Amazing Defenders</li>
                                <li>1 x Booster Pack Maze of Memories</li>
                                <li>1 x Promo Pack OTS 21</li>
                            </ul>
                        </div>
                        <div className="text-content">
                            Pentru a te inscrie iti poti rezerva locul <a href="https://krit.ro/produs/bilet-turneu-eecc-20mai">aici</a>, incepand cu 1 Mai - 20:00 (nu este necesar sa platesti acum) sau poti veni direct la standul Krit de la Comic Con inainte de turneu! (Locurile sunt limitate, iar rezervarile au prioritate)
                        </div>
                    </div>



                    <div className="group">
                        <div className="headline">
                            🏆 PREMII
                        </div>

                        <div className="prize-photos">

                        </div>

                        <div className="text-content">
                            <strong style={{fontSize: '1.8rem'}}>LOCUL 1</strong>
                            <br/>
                            <ul>
                                <li>1 x OTS Game Mat Cyber Dragon DUBLU!</li>
                                <li>1 x Display Yu-Gi-Oh! TCG Cyberstorm Access (24 booster packs)</li>
                                <li>1 x Display Yu-Gi-Oh! TCG Maze of Memories (24 booster packs)</li>
                            </ul>
                            <br/><br/>

                            <strong style={{fontSize: '1.6rem'}}>LOCUL 2</strong>
                            <br/>
                            <ul>
                                <li>1 x OTS Game Mat "Elemental Hero Spirit of Neos"</li>
                                <li>1 x Display Yu-Gi-Oh! TCG Maze of Memories (24 booster packs)</li>
                            </ul>
                            <br/><br/>


                            <strong style={{fontSize: '1.4rem'}}>LOCUL 3</strong>
                            <br/>
                            <ul>
                                <li>1 x OTS Game Mat "Brothers of Legend"</li>
                                <li>16 x Booster Packs (Cyberstorm Access / Maze of Memories)</li>
                            </ul>
                            <br/><br/>

                            <strong style={{fontSize: '1.2rem'}}>LOCUL 4</strong>
                            <br/>
                            <ul>
                                <li>1 x OTS Game Mat "Toon Chaos"</li>
                                <li>14 x Booster Packs (Cyberstorm Access / Maze of Memories)</li>
                            </ul>

                            <br/><br/>
                            <strong style={{fontSize: '1rem'}}>LOCUL 5</strong>
                            <br/>
                            <ul>
                                <li>1 x OTS Game Mat "Destiny HERO - Drawhand"</li>
                                <li>10 x Booster Packs (Cyberstorm Access / Maze of Memories)</li>
                            </ul>
                            <br/><br/>
                            <strong style={{fontSize: '1rem'}}>LOCUL 6</strong>
                            <br/>
                            <ul>
                                <li>1 x Game Mat "Destiny HERO - Drawhand"</li>
                                <li>8 x Booster Packs (Cyberstorm Access / Maze of Memories)</li>
                            </ul>
                            <br/><br/>


                            <strong>RAFFLE</strong>
                            <br/>
                            <ul>
                                <li>1 x OTS Game Mat "Brothers of Legend"</li>
                                <li>1 x OTS Game Mat "Toon Chaos"</li>
                                <li>1 x OTS Game Mat "Destiny Hero Drawhand"</li>
                                <li>21 x Promo Packs OTS 21</li>
                            </ul>
                        </div>
                    </div>

                    <div className="group">
                        <div className="headline">
                            📄 REGULAMENT &amp; RESURSE
                        </div>

                        <div className="text-content">
                            <a href="https://content.krit.ro/event-documents/290423-cyac-premiere/SD_RuleBook_EN_10.pdf">Regulile Jocului (Engleza)</a><br/>
                            <a href="https://www.yugioh-card.com/en/limited/list_02-13-2023/">Lista carti interzise / limitate (Valabil din 13 Februarie 2023)</a><br/>
                            <a href="https://content.krit.ro/event-documents/290423-cyac-premiere/KDE-E_TCG_Tournament_Policy_2_1.pdf">Regulament general turnee Yu-Gi-Oh! TCG (Engleza)</a><br/>
                            {/* <a href="https://content.krit.ro/event-documents/290423-cyac-premiere/regulament_oficial.pdf">Regulament Oficial</a><br/>
                            <a href="https://content.krit.ro/event-documents/290423-cyac-premiere/acord_parinti.pdf">Acord parinti (necesar pentru minori sub 16 ani)</a> */}
                        </div>
                    </div>



                    <div className="group">
                        <div className="headline">
                            📱 CONTACT
                        </div>

                    <div className="text-content">
                        Ai nevoie de mai multe informatii?
                        Ne gasesti la contact@krit.ro / 0773989236
                    </div>

                    </div>
                </div>
            </WidthWrapper>
        </>
    )
}

CyberstormAccess.getInitialProps = async function(ctx) {
    return {
        landingPage: true
    }
}
export default CyberstormAccess;
